import { Instance } from 'mobx-state-tree';
import { SessionCheckoutCompleteDtoModelBase } from './SessionCheckoutCompleteDtoModel.base';

/* The TypeScript type of an instance of SessionCheckoutCompleteDtoModel */
export interface SessionCheckoutCompleteDtoModelType extends Instance<typeof SessionCheckoutCompleteDtoModel.Type> {}

/* A graphql query fragment builders for SessionCheckoutCompleteDtoModel */
export { selectFromSessionCheckoutCompleteDto, sessionCheckoutCompleteDtoModelPrimitives, SessionCheckoutCompleteDtoModelSelector } from './SessionCheckoutCompleteDtoModel.base';

/**
 * SessionCheckoutCompleteDtoModel
 */
export const SessionCheckoutCompleteDtoModel = SessionCheckoutCompleteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
